import { ProductTag } from '../constants/products';

/**
 * Determines whether the alternate size guide should be used based on the provided list of tag IDs.
 *
 * @param {Array<string>} [tagIdList=[]] - An array of tag IDs to check. Defaults to an empty array.
 * @returns {boolean} - Returns `true` if the `ProductTag.altSizeGuidePDP` is included in the tag ID list, otherwise `false`.
 */
export function shouldUseAlternateSizeGuide(tagIdList = []) {
  return tagIdList?.includes(ProductTag.altSizeGuidePDP);
}
